import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-19150db9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mhp" }
const _hoisted_2 = { class: "mhp__modal" }
const _hoisted_3 = ["onMouseover", "onMouseleave", "onClick"]
const _hoisted_4 = { class: "mhp__modal-row-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPayment = _resolveComponent("IconPayment")!
  const _component_IconExit = _resolveComponent("IconExit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "mhp__overlay",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hiddenModal && _ctx.hiddenModal(...args)))
    }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "mhp__modal-row",
          onMouseover: ($event: any) => (_ctx.onHover(index)),
          onMouseleave: ($event: any) => (_ctx.onMouseleave(index)),
          onClick: ($event: any) => (_ctx.onClickRedirect(item.routeName))
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.ICON.PAY === index)
              ? (_openBlock(), _createBlock(_component_IconPayment, {
                  key: 0,
                  "is-hover": _ctx.hover.index === index && _ctx.hover.isHover
                }, null, 8, ["is-hover"]))
              : _createCommentVNode("", true),
            (_ctx.ICON.EXIT === index)
              ? (_openBlock(), _createBlock(_component_IconExit, {
                  key: 1,
                  "is-hover": _ctx.hover.index === index && _ctx.hover.isHover
                }, null, 8, ["is-hover"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(
						_ctx.hover.index === index && _ctx.hover.isHover
							? 'mhp__modal-row-label_green'
							: 'mhp__modal-row-label'
					)
          }, _toDisplayString(item.name), 3)
        ], 40, _hoisted_3))
      }), 128))
    ])
  ]))
}